import React from "react";
import { IconButton, MenuItem, TextField, Tooltip } from "@material-ui/core";
import {
  ArrowUpward as ArrowUpwardIcon,
  ArrowDownward as ArrowDownwardIcon,
  Delete as DeleteIcon,
} from "@material-ui/icons";

import GrupoCondiciones from "../filtros/grupo-condiciones";
import { FUENTES_BLOQUE, FUENTES_CON_FECHA } from "../filtros/filter-registry";

/**
 * Un bloque de la recomendación: qué porcentaje del total ocupa, de dónde salen sus
 * libros y qué condiciones los filtran.
 */
const BloqueEditor = ({
  bloque,
  indice,
  total,
  onChange,
  onRemove,
  onMover,
  opcionesApi,
  librosEstimados,
}) => {
  const admiteFechas = FUENTES_CON_FECHA.includes(bloque.fuente);
  const etiquetaFecha =
    bloque.fuente === "novedades" ? "Cargados entre" : "Lecturas entre";

  const set = (campo, valor) => onChange({ ...bloque, [campo]: valor });

  return (
    <div className="content-white-box px-3 py-3 mb-3" style={{ border: "1px solid #e0e0e0" }}>
      <div className="d-flex align-items-center justify-content-between mb-2">
        <div className="admin-main-title-dark-gray">
          Bloque {indice + 1}
          {typeof librosEstimados === "number"
            ? ` — ${librosEstimados} libros`
            : ""}
        </div>
        <div>
          <Tooltip title="Subir">
            <span>
              <IconButton
                size="small"
                disabled={indice === 0}
                onClick={() => onMover(-1)}
              >
                <ArrowUpwardIcon style={{ fontSize: 16 }} />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="Bajar">
            <span>
              <IconButton
                size="small"
                disabled={indice === total - 1}
                onClick={() => onMover(1)}
              >
                <ArrowDownwardIcon style={{ fontSize: 16 }} />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="Eliminar bloque">
            <span>
              <IconButton size="small" disabled={total <= 1} onClick={onRemove}>
                <DeleteIcon style={{ fontSize: 16 }} />
              </IconButton>
            </span>
          </Tooltip>
        </div>
      </div>

      <div className="d-flex flex-wrap">
        <TextField
          label="Nombre del bloque"
          value={bloque.nombre}
          onChange={(e) => set("nombre", e.target.value)}
          variant="outlined"
          size="small"
          className="mr-2 mb-2"
          style={{ width: "280px", fontFamily: "'Noto Sans JP', sans-serif" }}
        />
        <TextField
          label="Porcentaje"
          value={bloque.porcentaje}
          onChange={(e) => set("porcentaje", e.target.value)}
          variant="outlined"
          size="small"
          type="number"
          inputProps={{ min: 0, max: 100 }}
          className="mr-2 mb-2"
          style={{ width: "120px", fontFamily: "'Noto Sans JP', sans-serif" }}
        />
        <TextField
          select
          label="Fuente"
          value={bloque.fuente}
          onChange={(e) => set("fuente", e.target.value)}
          variant="outlined"
          size="small"
          className="mr-2 mb-2"
          style={{ width: "260px", fontFamily: "'Noto Sans JP', sans-serif" }}
        >
          {FUENTES_BLOQUE.map((fuente) => (
            <MenuItem key={fuente.value} value={fuente.value}>
              {fuente.label}
            </MenuItem>
          ))}
        </TextField>

        {admiteFechas && (
          <>
            <TextField
              label={etiquetaFecha}
              value={bloque.fechaInicio}
              onChange={(e) => set("fechaInicio", e.target.value)}
              variant="outlined"
              size="small"
              type="date"
              InputLabelProps={{ shrink: true }}
              className="mr-2 mb-2"
              style={{ width: "180px", fontFamily: "'Noto Sans JP', sans-serif" }}
            />
            <TextField
              label="Hasta"
              value={bloque.fechaFin}
              onChange={(e) => set("fechaFin", e.target.value)}
              variant="outlined"
              size="small"
              type="date"
              InputLabelProps={{ shrink: true }}
              className="mb-2"
              style={{ width: "180px", fontFamily: "'Noto Sans JP', sans-serif" }}
            />
          </>
        )}
      </div>

      <div className="mt-2">
        <GrupoCondiciones
          condiciones={bloque.condiciones ?? []}
          onChange={(condiciones) => set("condiciones", condiciones)}
          opcionesApi={opcionesApi}
          titulo="Condiciones del bloque"
          descripcion="Se suman a las condiciones globales y al territorio del alcance."
        />
      </div>
    </div>
  );
};

export default BloqueEditor;
